import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import { useHistory } from 'react-router'
import { getPermissions } from '../../../services/auth'

import CollaboratorRender from './CollaboratorRender'

function Home () {
  const [getLoading, setLoading] = useState(true)
  const [getContributors, setContributors] = useState([])
  const [getStatus, setStatus] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(50);
  const [pagination, setPagination] = useState([]);

  const history = useHistory()

  const getUsers = async (pageNumber = currentPage) => {
    setLoading(true)
    try {
      const response = await api.get(`Colaboradores/ConsultarGridCadastro?paginaInicial=${pageNumber}&itensPorPagina=${itensPerPage}${getStatus ? `&status=${getStatus}` : ''}&ignorarDiretoria=false&ignorarFernando=false`)

      setPagination(response.data.paginacao);
      if(response.data.paginacao.qtdTotalRegistros > 0){
        setContributors(response.data.resposta);
      } else {
        setContributors([]);
      }
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.')
    }
    setLoading(false)
  }

  const removeCollab = async (colaboradorId) => {
    try {
      const resultDelete = await api.delete(`Colaboradores?id=${colaboradorId}`)
      if (resultDelete.data.status !== 'Inconsistencia') {
        setContributors(getContributors.filter(el => el.colaboradorId !== colaboradorId))
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.')
    }
  }

  const findPermission = (permissao = null) => {
    if (getPermissions({ moduloId: 1344, permissao })) {
      return true
    }
    return false
  }

  const findUserAndPermission = () => {
    if (findPermission()) {
      getUsers(1)
    } else {
      history.push('/app')
    }
  }

  useEffect(() => {
    setCurrentPage(1);
    findUserAndPermission()
  }, [itensPerPage])

  return (
    <CollaboratorRender
      users={getContributors}
      loading={getLoading}
      getStatus={getStatus}
      setStatus={setStatus}
      removeCollab={removeCollab}
      findPermission={findPermission}
      findUserAndPermission={findUserAndPermission}
      setItensPerPage={setItensPerPage}
      currentPage={currentPage}
      pagination={pagination}
      itensPerPage={itensPerPage}
      setCurrentPage={setCurrentPage}
      getUsers={getUsers}
    />
  )
}

export default Home
